import { SignOutButton } from "./SignOutButton";

export const Logout = () => {
  return (
    <>
      <center>
        <h3>Signed in</h3>
        <SignOutButton />
      </center>
    </>
  );
};
